export default "__VITE_ASSET__Bt3kJDPK__"